import { create } from "zustand";

type ImportTrackerStore = {
  trackedIds: string[];
  track: (id: string) => void;
  untrack: (id: string) => void;
};

export const useImportTrackerStore = create<ImportTrackerStore>((set) => ({
  trackedIds: [],
  track: (id) =>
    set((state) =>
      state.trackedIds.includes(id)
        ? state
        : { trackedIds: [...state.trackedIds, id] },
    ),
  untrack: (id) =>
    set((state) => ({
      trackedIds: state.trackedIds.filter((tracked) => tracked !== id),
    })),
}));
